import React from "react";

import { useContentContext } from "../context/content-context";

import PatientPageWrapper from "../patient-site/components/patient-page-wrapper";
import HCPPageWrapper from "../hcp-site/components/hcp-page-wrapper";

const ThemedPageWrapper = ({ children }) => {
  const { isHCP, references } = useContentContext();

  const Wrapper = isHCP ? HCPPageWrapper : PatientPageWrapper;

  return <Wrapper references={references}>{children}</Wrapper>;
};

export default ThemedPageWrapper;
